<div>
    <h2>Selecione o emitente:</h2>
</div>

<div class="receipt-actions">
    <button mat-stroked-button class="mr-12 receipt-button" [disabled]="loadingReceipt" (click)="generateReceipt('C')">

        <span class="button-content">
            <span>{{ loadingReceipt === 'C' ? 'Gerando...' : 'Clínica' }}</span>

            <mat-icon *ngIf="loadingReceipt !== 'C'">picture_as_pdf</mat-icon>

            <mat-spinner *ngIf="loadingReceipt === 'C'" diameter="18">
            </mat-spinner>
        </span>
    </button>

    <button mat-stroked-button class="mr-12 receipt-button" [disabled]="loadingReceipt" (click)="generateReceipt('M')">

        <span class="button-content">
            <span>{{ loadingReceipt === 'M' ? 'Gerando...' : 'Profissional' }}</span>

            <mat-icon *ngIf="loadingReceipt !== 'M'">picture_as_pdf</mat-icon>

            <mat-spinner *ngIf="loadingReceipt === 'M'" diameter="18">
            </mat-spinner>
        </span>
    </button>
</div>